import React from "react";
import {Container, IconButton, IconFilterRounded} from "bounce-ui/backoffice";
import {AccountExternal} from "declerations/server/account_models";
import {IPlanMatrix} from "../../../../../../../../declerations/server/payment_plan_models";
import {PaymentTable} from "./PaymentTable";
import {FormControl, MenuItem, Select} from "@mui/material";
import {mapFrequencyToTitle} from "../../../../../../../account/payment-plans/utils";
import {KeyValueRow, StyledCard} from "../Components";
import {PaymentPlanBuilderFrequency} from "../utils";
import {getEnumLabelKey, paymentPlanBaseInfoMap} from "../../../../../../../../constants/enums";

interface IPlanMatrixCard {
  userBalance: AccountExternal;
  selectedPlan: IPlanMatrix | null;
  setSelectedPlan: (planMatrix: IPlanMatrix | null) => void;
  handleClickFilter: () => void;
  filteredPlanOffers: (IPlanMatrix | null)[][];
  frequency: PaymentPlanBuilderFrequency;
  setFrequency: (frequency: PaymentPlanBuilderFrequency) => void;
  setResetSelectedPlan: (value: boolean) => void;
}

const PlanMatrix = ({
  handleClickFilter,
  selectedPlan,
  filteredPlanOffers,
  setSelectedPlan,
  frequency,
  setFrequency,
  setResetSelectedPlan,
}: IPlanMatrixCard) => {
  const filteredFrequencyOptions = Object.fromEntries(
    Object.entries(mapFrequencyToTitle).filter(([key]) => !["one_time", "last_business_day_of_the_month"].includes(key))
  );

  const handleSelect = (event: any) => {
    setResetSelectedPlan(true);
    setFrequency(event.target.value);
  };

  return (
    <StyledCard>
      <KeyValueRow field={"Installment frequency & amount"}>
        <Container row>
          <IconButton onClick={handleClickFilter} sx={{padding: "0px"}}>
            <IconFilterRounded />
          </IconButton>
          <FormControl fullWidth>
            <Select value={frequency} onChange={handleSelect} sx={{height: "34px"}}>
              {Object.keys(filteredFrequencyOptions).map((frequency) => (
                <MenuItem key={frequency} value={frequency}>
                  {getEnumLabelKey(paymentPlanBaseInfoMap, frequency)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Container>
      </KeyValueRow>
      <PaymentTable
        planOffers={filteredPlanOffers}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
        frequency={frequency}
      />
    </StyledCard>
  );
};

export default PlanMatrix;
